import { render } from "./AdditionalInformation2.vue?vue&type=template&id=51a95378&scoped=true"
import script from "./AdditionalInformation2.vue?vue&type=script&lang=js"
export * from "./AdditionalInformation2.vue?vue&type=script&lang=js"

import "./AdditionalInformation2.vue?vue&type=style&index=0&id=51a95378&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a95378"]])

export default __exports__